import { createRouter } from "@tanstack/react-router";

import RouteError from "~/components/RouteError";
import RoutePending from "~/components/RoutePending";
import PageId from "~/utils/PageId";

import { routeTree } from "./routeTree.gen";

// react-router serialized search params via URLSearchParams. Keep that exact
// byte format ("+" for spaces, every value a plain string — no JSON typing)
// so pre-migration URLs survive any router-driven search serialization.
const parseSearch = (searchStr: string): Record<string, string> =>
  Object.fromEntries(new URLSearchParams(searchStr));

const stringifySearch = (search: Record<string, unknown>): string => {
  const params = new URLSearchParams();
  Object.entries(search).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  });
  const str = params.toString();
  return str ? `?${str}` : "";
};

export const router = createRouter({
  routeTree,
  parseSearch,
  stringifySearch,
  defaultPendingComponent: RoutePending,
  defaultErrorComponent: RouteError,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  // Per-route presentation metadata, plus the registry nav id the route guard
  // tests against the access payload.
  interface StaticDataRouteOption {
    pageId?: PageId;
    navId?: string;
    titleKey: string;
    hideTitle?: boolean;
    hideNav?: boolean;
  }
}
